<div class="header"
     data-automation-e2e-selector="header"
     [ngClass]="{'unread': (unseen | async) }"
     *ngIf="!(loading | async) && (reads | async)?.length > 0">
    {{timeOfDay | async}}
    <span class="textDefault highlight"
          data-automation-e2e-selector="event">
        {{(readType | async) === 'final' ? 'Final MMD Read' : 'Current MMD Read'}}
    </span>
</div>
<div class="header"
     data-automation-e2e-selector="header"
     *ngIf="!(loading | async) && (reads | async)?.length === 0">
     No MMD Reads Available
</div>
<div class="header"
     data-automation-e2e-selector="header"
     *ngIf="loading | async">
     Loading...
</div>